import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Mail, Phone, Send } from 'lucide-react';
import { Button } from './ui/Button';
export function ContactSection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-9">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-10">
        <img src="https://images.unsplash.com/photo-1550966871-3ed3c47e2ce2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="Luxury Interior" className="w-full h-full object-cover opacity-20" data-id="element-11" />
        <div className="absolute inset-0 bg-gradient-to-t from-dark-bg via-dark-bg/90 to-dark-bg/80" data-id="element-12" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-13">
        <div className="max-w-4xl mx-auto bg-dark-card/50 backdrop-blur-md border border-white/10 rounded-2xl p-8 md:p-16 text-center" data-id="element-14">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl md:text-5xl text-white mb-6" data-id="element-15">
            准备好开启您的<span className="text-gold-gradient" data-id="element-16">专属体验</span>
            了吗？
          </motion.h2>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-gray-300 text-lg mb-10 max-w-2xl mx-auto" data-id="element-17">
            立即联系我们的客服团队，我们将为您安排最适合您的伴游服务。严格保密，专业高效。
          </motion.p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-18">
            <motion.a href="#" whileHover={{
            scale: 1.05
          }} className="flex flex-col items-center p-6 bg-white/5 rounded-xl border border-white/10 hover:border-gold-500/50 hover:bg-gold-500/10 transition-all cursor-pointer" data-id="element-19">
              <MessageCircle className="w-8 h-8 text-green-500 mb-3" data-id="element-20" />
              <span className="text-white font-medium" data-id="element-21">WhatsApp</span>
              <span className="text-gray-500 text-sm mt-1" data-id="element-22">即时回复</span>
            </motion.a>

            <motion.a href="#" whileHover={{
            scale: 1.05
          }} className="flex flex-col items-center p-6 bg-white/5 rounded-xl border border-white/10 hover:border-gold-500/50 hover:bg-gold-500/10 transition-all cursor-pointer" data-id="element-23">
              <Send className="w-8 h-8 text-blue-400 mb-3" data-id="element-24" />
              <span className="text-white font-medium" data-id="element-25">Telegram</span>
              <span className="text-gray-500 text-sm mt-1" data-id="element-26">匿名咨询</span>
            </motion.a>

            <motion.a href="#" whileHover={{
            scale: 1.05
          }} className="flex flex-col items-center p-6 bg-white/5 rounded-xl border border-white/10 hover:border-gold-500/50 hover:bg-gold-500/10 transition-all cursor-pointer" data-id="element-27">
              <Mail className="w-8 h-8 text-gold-500 mb-3" data-id="element-28" />
              <span className="text-white font-medium" data-id="element-29">Email</span>
              <span className="text-gray-500 text-sm mt-1" data-id="element-30">商务合作</span>
            </motion.a>
          </div>

          <Button size="lg" className="w-full md:w-auto px-12 text-lg" data-id="element-31">
            立即预约
          </Button>
        </div>
      </div>
    </section>;
}